import React from "react";
import { Users, Layers, Handshake, Image } from "lucide-react";
import { CampaignItem } from "./index";
import { ProfileCardBase } from "./profile-card-base";

interface EnseigneCardProps {
  item: CampaignItem;
}

export function EnseigneCard({ item }: EnseigneCardProps) {
  const formatContribution = (contribution?: number) => {
    if (!contribution) return "N.C.";
    return `${Math.round(contribution / 1000)}k€`;
  };

  return (
    <ProfileCardBase
      name={item.name}
      logoUrl={item.logo_url}
      fallbackIcon={Image}
      profileId={item.id}
      profileType="Profile::Enseigne"
      userId={item.user_id}
      entity={item}
      items={[
        {
          icon: Users,
          label: "Zone de ch.",
          value: item.chalandise || "N.C.",
        },
        {
          icon: Layers,
          label: "Surface",
          value: item.surface_display || "N.C.",
        },
        {
          icon: Handshake,
          label: "Apport",
          value: formatContribution(item.contribution),
        },
      ]}
    />
  );
}
